import { env } from '@/shared/config/env.js';

export function isDesignSystemPreviewEnabled(): boolean {
  return import.meta.env.DEV || env.VITE_ENABLE_DS_PREVIEW;
}

export function isDesignSystemPreviewPath(pathname: string): boolean {
  return pathname === '/harness/design-system' || pathname.startsWith('/harness/design-system');
}
